import { createStandardAction } from 'typesafe-actions';

export const openCalendarModal = createStandardAction('OPEN_MODAL_CALENDER')();
export const closeCalendarModal = createStandardAction('CLOSE_MODAL_CALENDER')();
